// create FSA find conversation request action
export const DOWNLOAD_CHAT_CONVERSATION_REQUEST = 'DOWNLOAD_CHAT_CONVERSATION_REQUEST';

export const downloadChatConversationRequest = ({ id }) => ({
    type: DOWNLOAD_CHAT_CONVERSATION_REQUEST,
    payload: {
        id,
    },
});
